<template>
  <div class="recharge-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="$router.back()" />
      </div>
      <span class="head_text">{{ $t('充值') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <!-- 存款方式选择 -->
<!--      <div class="typelis">-->
<!--        <div :class="pay_way == 'bank' ? ' tyls atc' : 'tyls'" @click="changPayway('bank')" v-if="payWayList.card == 1"><img src="/static/image/new/mine/icoOnlineTransger.png" alt="" />{{ $t('网银转账') }}</div>-->
<!--        <div :class="pay_way == 'usdt' ? ' tyls atc' : 'tyls'" @click="changPayway('usdt')" v-if="payWayList.usdt == 1"><img src="/static/image/1595237922936176.png" alt="" />USDT</div>-->
<!--        <div :class="pay_way == 'wechat' ? ' tyls atc' : 'tyls'" @click="changPayway('wechat')" v-if="payWayList.wechat == 1"><img src="/static/image/QuickWechat.png" alt="" />{{ $t('微信') }}</div>-->
<!--        <div :class="pay_way == 'alipay' ? ' tyls atc' : 'tyls'" @click="changPayway('alipay')" v-if="payWayList.alipay == 1"><img src="/static/image/icoAlipay2@3x.png" alt="" />{{ $t('支付宝') }}</div>-->
<!--      </div>-->
<!--      <div v-if="pay_way == 'bank' && !(userbank.length == 0 && userUSD.length == 0)">-->
<!--      <div v-if="pay_way == 'bank'">-->
<!--        <div class="usrse">-->
<!--          <div class="bans" style="" v-for="(item, index) in cardLis" :key="index">-->
<!--            <p>-->
<!--              <span class="frists"> {{ $t('收款账号') }} </span><span class="sdsw">{{ item.bank_no }}</span-->
<!--              ><span class="copy" @click="doCopy(item.bank_no)"> {{ $t('复制') }} </span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="frists"> {{ $t('银行户名') }} </span><span class="sdsw">{{ item.bank_owner }}</span-->
<!--              ><span class="copy" @click="doCopy(item.bank_owner)"> {{ $t('复制') }} </span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="frists"> {{ $t('开户行') }} </span><span class="sdsw">{{ item.bank_data.bank_name }}</span-->
<!--              ><span class="copy" @click="doCopy(item.bank_data.bank_name)"> {{ $t('复制') }} </span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="frists"> {{ $t('银行地址') }} </span><span class="sdsw">{{ item.bank_address }}</span-->
<!--              ><span class="copy" @click="doCopy(item.bank_address)"> {{ $t('复制') }} </span>-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="hgs" @click="changShow">-->
<!--            <div class="nams">{{ $t('开户银行') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field v-model="bankBox.bank" type="text" :placeholder="$t('选择开户银行')" disabled> </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('存款人姓名') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field v-model="bankBox.bank_owner" type="text" :placeholder="$t('请输入存款人姓名')"> </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--            <div class="lasthg">{{ $t('请务必输入正确的存款人姓名') }}</div>-->
<!--          </div>-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('银行卡号') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field v-model="bankBox.bank_no" type="text" :placeholder="$t('请输入银行卡号')"> </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('开户行地址') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field v-model="bankBox.bank_address" type="text" :placeholder="$t('请输入开户行地址')"> </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('存款金额') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field label="" v-model="amount" type="text" :placeholder="`${$t('请输入取款金额')} ${min_price} - ${max_price}`">-->
<!--                  <template #button> <span style="color: #000"> {{ $t('元') }}</span> </template>-->
<!--                </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--            <div class="lasthg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-if="pay_way == 'usdt'">-->
<!--        <div class="tipsh">-->
<!--          <div class="tops">{{ $t('USDT价格稳定') }} {{ $t('流通性高') }} {{ $t('不受监管') }} <span @click="$parent.goNav('/usdtmore')">{{ $t('了解更多') }} ></span></div>-->
<!--          <div class="tsg">-->
<!--            <div class="tsgs">{{ $t('绑定协议地址') }}</div>-->
<!--            <div class="tsgs">{{ $t('交易所划转') }}</div>-->
<!--            <div class="tsgs">{{ $t('完成取款') }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="usrse">-->
<!--          <div class="hgs">-->
<!--            <div class="nams sc">-->
<!--              {{ $t('钱包协议') }}-->
<!--              <div :class="meyXi == 'TRC20' ? ' ssa acti' : 'ssa'" @click="changXiyi('TRC20')">TRC20</div>-->
<!--              <div :class="meyXi == 'ERC20' ? ' ssa acti' : 'ssa'" style="margin-left: 0.5rem" @click="changXiyi('ERC20')">ERC20</div>-->
<!--            </div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2"></div>-->
<!--          </div>-->
<!--          &lt;!&ndash; <div class="hgs">-->
<!--            <div class="nams">USDT地址</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <div data-v-a12ec382="" class="van-cell-group van-hairline&#45;&#45;top-bottom">-->
<!--                <div data-v-a12ec382="" class="van-cell van-field">-->
<!--                  <div class="van-cell__value van-cell__value&#45;&#45;alone van-field__value">-->
<!--                    <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" placeholder="请输入USDT地址" class="van-field__control" /></div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div> &ndash;&gt;-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('存款金额') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field label="" v-model="amount" type="text" :placeholder="`${$t('请输入取款金额')} ${min_price} - ${max_price}`">-->
<!--                  <template #button> <span style="color: #000"> {{ $t('元') }}</span> </template>-->
<!--                </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--            <div class="lasthg"><span style="color: red; font-size: 0.43rem; margin-right: 10px">≈ </span> {{ amount ? Math.floor((amount / $store.state.userInfo.usdtrate) * 100) / 100 : '0.00' }}USDT ; {{ $t('参考汇率') }}：{{ $store.state.userInfo.usdtrate }}</div>-->
<!--          </div>-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('温馨提示') }}</div>-->
<!--            <div class="lasthg" style="border-top: 1px solid #eee; margin-top: 10px">{{ $t('温馨提示内容') }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-if="pay_way == 'wechat' || pay_way == 'alipay'">-->
<!--        <div class="usrse">-->
<!--          <div class="hgs">-->
<!--            <div class="nams">{{ $t('存款金额') }}</div>-->
<!--            <div style="border-bottom: 1px solid #f2f2f2">-->
<!--              <van-cell-group>-->
<!--                <van-field label="" v-model="amount" type="text" :placeholder="`${$t('请输入取款金额')} ${min_price} - ${max_price}`">-->
<!--                  <template #button> <span style="color: #000"> {{ $t('元') }}</span> </template>-->
<!--                </van-field>-->
<!--              </van-cell-group>-->
<!--            </div>-->
<!--            <div class="lasthg"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="wx-pay-info">
        <div class="wallet-info">
          <div class="info">
            <img src="/static/image/new/mine/qianbao.png" class="wallet-icon" alt="">
            <span>中心钱包</span>
            <img src="/static/image/new/mine/eye-icon.png" class="eye-icon" alt="">
          </div>
          <div class="balance">
            {{ $store.state.userInfo.balance || 0 }}
            <img src="/static/image/new/mine/refresh-icon.png" @click="getBalance" :class="{'refresh-icon': true, 'rotated-image': balance_loading}" alt="">
          </div>
        </div>
        <div>
          <div :class="{'pay-type': true, 'active': pay_way === 'wechat'}" @click="changPayway('wechat')">
            <em>支付方式</em>
            <img src="/static/image/new/mine/pay-wx.png" class="wx-img" alt="">
            <span>微信</span>
            <span class="amount">{{ amount }}</span>
          </div>
          <div :class="{'pay-type': true, 'active': pay_way === 'alipay'}" @click="changPayway('alipay')">
            <em></em>
            <img src="/static/image/new/mine/pay-alipay.png" class="wx-img" alt="">
            <span>支付宝</span>
            <span class="amount">{{ amount }}</span>
          </div>
          <div :class="{'pay-type': true, 'active': pay_way === 'bank'}" @click="changPayway('bank')">
            <em></em>
            <img src="/static/image/new/mine/pay-bank.png" class="wx-img" alt="">
            <span>银行卡</span>
            <span class="amount">{{ amount }}</span>
          </div>
        </div>
        <div class="recharge-money-box">
          <div class="recharge-title">余额充值</div>
          <div class="money-list">
            <div :class="{'money-item': true, 'active': amount == item}" v-for="(item,index) in money_list" @click="amount = item" :key="index">{{item}}</div>
          </div>
          <div class="recharge-input">
            ¥ <input type="number" v-model="amount" placeholder="请输入充值金额">
            <img src="/static/image/new/mine/recharge-close.png" @click="amount = null" class="close" alt="">
          </div>
          <div class="recharge-tips">充值限额：{{ min_price }} - {{ max_price }}</div>
        </div>

      </div>
      <div style="padding: 0 .4rem;">

        <div class="submit" @click="payTest">{{ $t('立即存款') }}</div>
<!--        <div class="textcns" style=" color: #bbb; padding: .53rem 0;">{{ $t('存款遇到问题') }}？{{ $t('联系') }} <span @click="$parent.openKefu" style="color: #4B5BF1; margin: 0 .08rem">{{ $t('人工客服') }}</span>-->
<!--          {{ $t('解决') }}</div>-->
      </div>
    </div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" :title="$t('银行类型')" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
    <!-- 禁止   -->
  </div>
</template>
<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: 'TRC20',
      payWayList: {},
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      money_list: [100, 500, 1000, 2000, 5000, 10000, 50000],
      balance_loading: false
    };
  },
  created() {
    let that = this;
    that.getPayWay();
    that.getBanklist();
    that.getcard();
  },
  methods: {
    getBalance() {
      let that = this;
      that.balance_loading = true
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          that.balance_loading = false
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
        })
        .catch(res => {
          that.balance_loading = true
        });
    },
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') {
        type = 'bank';
      }
      if (that.pay_way == 'wechat') {
        type = 'wechat';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    changXiyi(val) {
      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      this.getPayRange();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            let obj = that.payWayList;
            for (let i in obj) {
              if (obj[i] == 1) {
                // that.pay_way = i == 'card' ? 'bank' : i;
                that.pay_way =  'wechat';
                that.hideLoading();
                that.getPayRange();

                return;
              }
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    payTest() {
      let that = this;
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      // if (that.pay_way == 'bank') {
      //   info = {
      //     paytype: that.pay_way,
      //     amount: that.amount * 1,
      //     bank: that.bankBox.bank,
      //     bank_address: that.bankBox.bank_address,
      //     bank_no: that.bankBox.bank_no,
      //     bank_owner: that.bankBox.bank_owner,
      //   };
      //   console.log(info);
      //   // 银行卡信息内容的限制
      //   if (!info.bank_owner) {
      //     that.showTost(0, that.$t('请输入存款人姓名'));
      //     return;
      //   }
      //   if (!info.bank) {
      //     that.showTost(0, that.$t('请输入银行类型'));
      //     return;
      //   }
      //
      //   if (!info.bank_no) {
      //     that.showTost(0, that.$t('请输入银行卡号'));
      //     return;
      //   }
      //   if (!info.bank_address) {
      //     that.showTost(0, that.$t('请输入银行开户行地址'));
      //     return;
      //   }
      // } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      // }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        // that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        that.showTost(0, that.$t(`请输入金额区间`,{
          min_price: that.min_price,
          max_price: that.max_price,
        }));
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            // if (that.pay_way == 'bank') {
            //   that.showTost(1, that.$t('等待后台审核'));
            //   that.bankBox = {};
            //   that.amount = null;
            //   that.hideLoading();
            //   that.$router.push({ path: '/transRecord' });
            //   return;
            // }
            that.bankBox = {};
            that.amount = null;
            that.$parent.openKefu();
            // that.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.getPayRange();
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, this.$t('复制成功') + '！');
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
};
</script>
<style>
.van-field__control {
  color: #fff !important;
}
</style>
<style lang="scss" scoped>
@import '../../static/css/2d87bbdbffeb4734e5c7.css';
.recharge-page {
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-size: cover;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  text-align: center;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.48rem;
      color: #fff;
      width: 55%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    .wx-pay-info {
      padding: 0 .4rem;
      .wallet-info {
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .27rem;
        padding: .32rem;
        box-sizing: border-box;
        .info {
          display: flex;
          align-items: center;
          .wallet-icon {
            width: 0.48rem;
            height: 0.48rem;
            margin-right: .27rem;
            margin-bottom: .1rem;
          }
          .eye-icon {
            width: 0.43rem;
            height: 0.43rem;
            margin-left: .16rem;
          }
        }
        .balance {
          display: flex;
          align-items: center;
          font-family: Gilroy, Gilroy;
          font-weight: 500;
          font-size: 0.59rem;
          color: #E89A00;
          margin-top: .43rem;
          .refresh-icon {
            width: 0.4rem;
            height: 0.4rem;
            margin-left: .27rem;
          }
          .rotated-image {
            animation: rotate 0.5s linear infinite;
          }
          @keyframes rotate {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        }
      }
      .pay-type {
        display: flex;
        align-items: center;
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .27rem;
        padding: 0 .32rem;
        height: 1.17rem;
        font-size: 0.37rem;
        margin-top: .27rem;
        position: relative;
        em {
          font-style: normal;
          font-size: 0.37rem;
          width: 1.8rem;
        }
        .wx-img {
          width: 0.75rem;
          height: 0.75rem;
          margin: 0 .27rem;
        }
        span {
          margin-right: .23rem;
          font-size: 0.32rem;
          display: flex;
          width: 1.2rem;
        }
        .amount {
          font-size: 0.32rem;
          color: #E89A00;
        }
        &.active {
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: .27rem;
            width: 0.37rem;
            height: 0.37rem;
            background-image: url("/static/image/new/mine/arrow-bottom.png");
            background-size: 100% 100%;
          }
        }
      }
      .recharge-money-box {
        background: rgba(255, 255, 255, 0.10);
        border: .03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .27rem;
        margin-top: .27rem;
        padding: .32rem;
        .recharge-title {
          font-size: 0.37rem;
          text-align: left;
        }
        .money-list {
          display: flex;
          flex-wrap: wrap;
          .money-item {
            width: 1.57rem;
            height: .75rem;
            background: #3D3D3D;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: .16rem;
            margin-top: .27rem;
            margin-right: .16rem;
            font-size: 0.37rem;
            &:nth-child(5n+5) {
              margin-right: 0;
            }
            &.active {
              color: #E89A00;
            }
          }
        }
        .recharge-input {
          background: rgba(255, 255, 255, 0.10);
          border: .03rem solid rgba(255, 255, 255, 0.10);
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 1.12rem;
          margin-top: .27rem;
          padding: 0 .37rem;
          font-size: .4rem;
          border-radius: .16rem;
          input {
            flex: 1;
            margin-left: .16rem;
            background: transparent;
            border: none;
            outline: none;
            color: #E89A00;
            font-size: .43rem;
          }
          .close {
            width: 0.37rem;
          }
        }
        .recharge-tips {
          font-size: 0.32rem;
          color: #7B7B7B;
          padding: .27rem 0;
          text-align: left;
        }
      }
    }
  }
  .tipsh {
    width: 100%;
    box-sizing: border-box;
    .tops {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.4rem;
      font-weight: 700;
      color: #333;
      height: 1rem;
      span {
        font-size: 0.29rem;
        font-weight: 400;
      }
    }
    .tsg {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tsgs {
        height: 0.56rem;
        line-height: 0.56rem;
        color: #a5a9b3;
        font-size: 0.2rem;
        text-align: center;
        padding: 4px 8px;
        flex: 1;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA0CAYAAADPCHf8AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALCSURBVHgB7d0hcNtAEIXhtWh4y8vDixseXHPz4ibYKW2Kw1UsHt7g8vCWB7u7mYsnss7S3elmam3+b8bjxM6Evaz1tFJWu91uKyLnAixbt1qt7qSyRh+3Aizfpf6xv5TKGk3dX31uBVi+jYak6qehJjx3+ngSYPmuNCTvpZLngOgUsXBU//wG/Adn+thqSM6kgpcJYiG516ffAizfO31cSQXNwfc/BfDhXKfIRmbqBUSniE2QewF8sGZrLTM0kdfsWIQDdnix1pB8lEKDgIQD9k4AP75oSD5IgdgEsZDYeZE/AvhgjVZR/duMvPdDAD+s2fqaW/8eDUg4YKf2hSf2MSur2Wom3mdPC95c5DRbowFhTwtOWbN1kfKDUxPEsKcFjzYpzdZkQNjTglNJzVbKBGFPC15NNltJAQnY04JHo81WckDY04JjR5utnAli2NOCV+vYJbtZAWFPC84Nmq3cCWIsIOxpwavt62YrOyBhirCnBa96l+yWTBD2tODd/pLdlRTShNkv4QQiPOuKJgjwRjzNCcisa32BE/dgFw4WBSRsQiZtQwILZFvs3+2L0gnyWQCfLBzXoa3ND0g4JV/t1o7AibnRcOzP82UFJDRX1e+gDZyIOw3H4+sXcieITY8q9zwFTkyr4RisUSUHJEwPDszh0UO41dVAzgTZCuDPvrGKSQpIqHU5MIc3vcYqZjIg4aMVtS68sVD0GquYlAlirRXTA960h41VzGhAqHXhVLSxipmaIOxbwZvuWGMVczQg7FvBocfc/6U+NkE4MIcn1lh9k0zRgLBvBWessbqeaqxiBgEJB+afBPDjtiQcJjZBmB7wxBqrX1KoFxD2reBMVmMVczhB2LeCF9mNVcw+IOxbwZGixirmOSDsW8GR4sYq5mWCMD3gxU2tcJgmTA9WSuBBG+76WY1NEMIBD9q5jVXMPzyG0oj5jr9QAAAAAElFTkSuQmCC);
        background-size: cover;
      }
    }
  }
  .usrse {
    box-sizing: border-box;
    padding-top: 5px;
    .hgs {
      width: calc(100% - 40px);
      margin: 0 auto;
    }
    .nams {
      font-size: 0.38rem;
      color: #000;
      vertical-align: middle;
      margin-top: 10px;
      font-weight: 700;
    }
    .imgsa {
      position: relative;
      height: 2rem;
      border-bottom: 1px solid #f2f2f2;
      padding-bottom: 0.2rem;
      .bisn {
        width: 0.8rem;
        position: absolute;
        bottom: 0.3rem;
        left: 1.4rem;
      }
      img {
        width: 2rem;
        border-radius: 50%;
      }
    }
  }
  [class*='van-hairline']:after {
    border: none;
  }
  .sc {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .ssa {
      border-radius: 5px;
      border: 1px solid #f1f1f1;
      width: 2rem;
      height: 1rem;
      line-height: 1rem;
      font-size: 0.4rem;
      font-weight: 700;
      text-align: center;
      margin-left: 1rem;
    }
    .acti {
      color: #cf866b !important;
      border: 1px solid #cf866b !important;
    }
  }
  .typelis {
    width: 100%;
    box-sizing: border-box;
    padding: .2rem .4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tyls {
      border-radius: .19rem;
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      background: rgba(255, 255, 255, 0.10);
      text-align: center;
      width: 2.35rem;
      height: 1.84rem;
      font-size: 0.3rem;
      color: #bbb;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        width: 0.69rem;
        display: block;
        margin-bottom: 0.16rem;
      }
    }
    .tyls.atc {
      border: 0.03rem solid rgba(255, 255, 255, 0.10);
      color: #A3D1FF;
    }
  }
  .lasthg {
    display: flex;
    align-items: center;
    font-size: 0.33rem;
    color: #a5a9b3;
    padding: 0.2rem 0;
  }

  .submit {
    height: 1.17rem;
    margin-top: .53rem;
    background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
    border-radius: .6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.43rem;
  }
  .bans {
    //background-image: linear-gradient(180deg, #fff, #f9fcff);
    width: 90%;
    margin: 0 auto;
    padding: 20px;
    border-radius: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .frists {
        width: 60px;
      }
      .sdsw {
        flex: 1;
      }
      .copy {
        color: #069b71;
      }
    }
  }
  .van-cell-group {
    background: transparent;
  }
  .van-cell {
    background: transparent;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/recharge.vue